import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from "moment";
import "@/assets/css/reset.css";
import "@/assets/css/color.css";
import Vant from 'vant';
import 'vant/lib/index.css';
import { DatetimePicker } from 'vant';

const app = createApp(App);
app.use(moment);
app.use(Vant);
app.use(DatetimePicker);
app.use(store).use(router).mount('#app');
